module.exports = __webpack_public_path__ + "img/logo-light.00d30924.png";